import { constants } from "../constants/redux-constants";

const initialState = {
  resetTriggered: 0,
};

const resetConversationReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_CONVERSATION:
      return {
        ...state,
        resetTriggered: state?.resetTriggered + 1,
      };
    default:
      return state;
  }
};

export default resetConversationReducer;
